import React, { useContext } from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { FirstName, LastName } from "../../utils/getName";
import { ThemeContext } from "../theme/ThemeProvider"; // import ThemeContext

import './About.css';

import profile from '../../assets/recentprojects/banner.gif';

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const About = () => {
  const classes = useStyles();
  const greetings = "Hello there!";
  const aboutme = `${FirstName} ${LastName}, a passionate and dedicated Junior MERN Stack Developer based in Dhaka, Bangladesh. I specialize in building responsive and user-friendly web applications using MongoDB, Express.js, React.js, and Node.js. With a strong foundation in web development, I have hands-on experience creating dynamic projects, integrating APIs, and optimizing performance for an exceptional user experience.`;

  const { theme } = useContext(ThemeContext); // Get current theme

  // Define styles based on the theme
  const textStyle = {
    color: theme === "light" ? "#000" : "#fff", // Light theme text is black, dark theme text is white
  };

  return (
    <div>
      <section id="about">
        <div className="about-title">
          <p style={textStyle}>About me</p> {/* Apply dynamic style here */}
        </div>
        <Container component="main" className={classes.main} maxWidth="md">
          <div className="about">
            <div
              className="_img"
              style={{
                background: `url(${profile})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>
            <div className="_content_wrapper">
              <Typography component="h2" variant="h5" style={textStyle}>
                <TextDecrypt text={`${greetings}`} />
              </Typography>
              <p className="aboutme" style={textStyle}>
                {aboutme}
              </p>
              <a href="#contact" className="contact-btn">
                <i className="fas fa-terminal"></i>
                <Typography component="span" style={textStyle}> Send me a message.</Typography>
              </a>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};
